module.exports = __webpack_public_path__ + "static/media/28_A.d894e98d.png";